import React from "react";
import styles from "../../../CSS/sections/CTASection.module.css";
import Button from "../ui/Button";
import { ArrowRight } from "lucide-react";

const CTASection = ({ content }) => {
  const { title, description, ctas, bgImage } = content;
  return (
    <section
      className={`${styles.ctaSection} padding-y`}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 text-center">
            <div className={styles.ctaContent}>
              <h2 className="heading2 text-light mb-3">{title}</h2>
              <p
                className="text-light text-center mx-auto mb-4"
                style={{ maxWidth: "636px" }}
              >
                {description}
              </p>
              {ctas.map((cta, idx) => {
                const isLight = cta.variant === "light";
                return (
                  <Button
                    key={idx}
                    label={cta.text}
                    url={cta.href}
                    target={cta?.target}
                    variant={cta.variant}
                    textColor={isLight ? "#000" : undefined}
                    rightIcon={isLight ? ArrowRight : undefined}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;